import React from "react";

class Dropdown extends React.Component {
  render() {
    return (
      <>
        <div className="dropdown">
          <button
          className="nav-cus-item"
            style={{
              backgroundColor: "transparent",
              color: "white",
              border: "none",
              display: "inline-block",
              textAlign: "center",
              fontWeight: "400",
              textDecoration: "none",
            }}
          >
            Categories
          </button>
          <div
            style={{ width: "200px", border: "none" }}
            className="dropdown-content"
          >
            {/* <span
              style={{ backgroundColor: "transparent", border: "none" }}
            ></span> */}
            <a
              style={{ fontSize: 12, textDecoration: "none" }}
              rel="noopener"
              // target="_blank"
              href="/asr"
            >
              Automatic Speech Recognition
            </a>
            <a
              style={{ fontSize: 12, textDecoration: "none" }}
              rel="noopener"
              // target="_blank"
              href="/cv"
            >
              Computer Vision
            </a>
            <a
              style={{ fontSize: 12, textDecoration: "none" }}
              rel="noopener"
              // target="_blank"
              href="/nlp"
            >
             Natural Lanaguage Processing
            </a>
            <a
              style={{ fontSize: 12, textDecoration: "none" }}
              rel="noopener"
              // target="_blank"
              href="/story"
            >
              Others
            </a>
          </div>
        </div>
      </>
    );
  }
}

export default Dropdown;
